export default __webpack_public_path__ + "media/images/images/raty/smiley/4-e3cd2b503b84e65a440892776a3919ae.png";